export default __webpack_public_path__ + "static/media/emmanuel.b2ebc1c8.png";